import { Component, OnDestroy, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

import { Dietitian } from '../../../../data/dietitian/domain/dietitian';
import { SegmentedNavigationItemModel } from '../../components/segmented-navigation/components/segmented-navigation-item/segmented-navigation-item.model';
import { SegmentedNavigationComponent } from '../../components/segmented-navigation/segmented-navigation.component';
import { NewCustomTrackerModalComponent } from './components/new-tracker-modal/new-custom-tracker-modal.component';
import {
  CustomTrackersFacade,
  CustomTrackersViewModel,
} from './custom-trackers.facade';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-custom-trackers',
  templateUrl: './custom-trackers.component.html',
  styleUrls: ['./custom-trackers.component.scss'],
  providers: [CustomTrackersFacade],
})
export class CustomTrackersComponent implements OnDestroy {
  @ViewChild('tabs')
  private tabs: SegmentedNavigationComponent;
  private routerEventsSubscription: Subscription;
  public bsModalRef: BsModalRef;
  segmentedItems: SegmentedNavigationItemModel[] = [
    new SegmentedNavigationItemModel('profil', 'Profil par défaut'),
    new SegmentedNavigationItemModel('list', 'Mes trackers'),
  ];
  dashboardStatus$: Observable<CustomTrackersViewModel>;
  dietitian: Dietitian;

  constructor(
    router: Router,
    private modalService: BsModalService,
    private facade: CustomTrackersFacade,
  ) {
    this.dashboardStatus$ = this.facade.dashboardStatus$;

    this.dashboardStatus$.subscribe((status) => {
      if (!status.isLoading && status.dietitian) {
        this.dietitian = status.dietitian;
      }
    });

    this.routerEventsSubscription = router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url === '/dashboard/trackers') {
          this.segmentedItems.forEach((item) => {
            item.isActive = item.id === 'profil';
          });
          if (this.tabs) {
            this.tabs.setActiveItem();
          }
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.routerEventsSubscription?.unsubscribe();
  }

  showTrackersCreationModal(): void {
    const initialState: ModalOptions = {
      initialState: {
        dietitian: this.dietitian,
      },
      class: 'modal-lg modal-dialog-centered',
    };
    this.bsModalRef = this.modalService.show(
      NewCustomTrackerModalComponent,
      initialState,
    );

    if (this.bsModalRef.content instanceof NewCustomTrackerModalComponent) {
      this.bsModalRef.content.validate.subscribe(() => {
        this.facade.updateWithCustomTracker(this.dietitian).then();
      });
    }
  }
}
